import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})

export class MasterService {
    // Define API
    apiURL = environment.apiBaseUrl; //'http://localhost:59094/';
    issuerURL=environment.issuer_uri;

    constructor(private http: HttpClient) { }
    /*========================================
    CRUD Methods for consuming RESTful API
    =========================================*/
    // Http Options
    // Http Options
    private GetHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.jwtToken()
            })
        }
    }

    httpOptions_file = {
        headers: new HttpHeaders({
            'Authorization': 'Bearer ' + this.jwtToken()
        })
    };

    private GetFileHttpOptions() {
        return {
            responseType: "blob",
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.jwtToken()
            })
        };
    }

    // JWT token access
    public jwtToken() {
        return sessionStorage.getItem('iammwtoken');
        // if (struser) {
        //     const currentAccess = JSON.parse(struser);
        //     // create authorization header with jwt token
        //     if (currentAccess && currentAccess.token) {
        //         return currentAccess.token;
        //     }
        // }
    }

    // FSC //
  public getMySignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/mySignals', objFSCType, this.GetHttpOptions());
    }    
    public getAllSignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AllSignals', objFSCType, this.GetHttpOptions());
    }

    public getSignalRating(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalRating', objFSCType, this.GetHttpOptions());
    }

   

    public UpdateMyRating(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/UpdateMyRating', objFSCType, this.GetHttpOptions());
    }

    public ApproveSignal(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/ApproveSignalData', objFSCType, this.GetHttpOptions());
    }


    public RejectSignal(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/RejectSignalData', objFSCType, this.GetHttpOptions());
    }

    public getUserList(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/Userlist', objFSCType, this.GetHttpOptions());
    }

    public AddnewUser(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AddUserInfo', objFSCType, this.GetHttpOptions());
    }

    public Updateuser(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/UpdateUser', objFSCType, this.GetHttpOptions());
    }

    public Logoutuser(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/Logout', objFSCType, this.GetHttpOptions());
    }
    public getSteepList(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/MstSteepData', objFSCType, this.GetHttpOptions());
    }


    public getTrendList(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/MstTrendData', objFSCType, this.GetHttpOptions());
    }

    public getSignalApprovalList(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalApprovalList', objFSCType, this.GetHttpOptions());
    }

    public getAllAdminSignals(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AllAdminSignals', objFSCType, this.GetHttpOptions());
    }

    public getRelevantSignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/RelevantSignals', objFSCType, this.GetHttpOptions());
    }

    public getAdvanceSearchSignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalsAdvancedsearch', objFSCType, this.GetHttpOptions());
    }

    public getSignalAttachments(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalAttachment', objFSCType, this.GetHttpOptions());
    }

    public getSignalOwners(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalOwners', objFSCType, this.GetHttpOptions());
    }

    public getSignalStatByRating(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalStatByRating', objFSCType, this.GetHttpOptions());
    }

    public getAdminSignalStatByRating(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AdminSignalStatByRating', objFSCType, this.GetHttpOptions());
    }

    public AddSignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AddSignalData', objFSCType, this.GetHttpOptions());
    }

    public UpdateSignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/UpdateSignalData', objFSCType, this.GetHttpOptions());
    }

    public ShareSignalData(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/ShareMySignal', objFSCType, this.GetHttpOptions());
    }

    public getSignalStatBySteep(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalStatBySteep', objFSCType, this.GetHttpOptions());
    }

    public getSignalStatByTrend(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalStatByTrend', objFSCType, this.GetHttpOptions());
    }

    public getAllSignalStatus(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AllSignalStatus', objFSCType, this.GetHttpOptions());
    }

    public getAllAdminSignalStatus(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/AllAdminSignalStatus', objFSCType, this.GetHttpOptions());
    }

    public getMySignalStatus(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/MySignalStatus', objFSCType, this.GetHttpOptions());
    }

    public getMyDivSignalStatus(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/MyDivSignalStatus', objFSCType, this.GetHttpOptions());
    }

    public getMyAdminDivSignalStatus(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/MyAdminDivSignalStatus', objFSCType, this.GetHttpOptions());
    }
    public DeleteSignals(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/DeleteSignals', objFSCType, this.GetHttpOptions());
    }


    public getSignalGroupCount(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/SignalGroupCount', objFSCType, this.GetHttpOptions());
    }

    public getMyNotification(objFSCType) {
        return this.http.post(this.apiURL + '/api/Master/MyNotification', objFSCType, this.GetHttpOptions());
    }

    //attendees//
    public getAttendees(objAttendees) {

        return this.http.post(this.apiURL + '/api/MasterMOM/GetAttendees', objAttendees, this.GetHttpOptions());
    }
    public addEditAttendees(objAttendees) {
        return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateAttendees', objAttendees, this.GetHttpOptions());
    }
    public deleteAttendees(objAttendees) {
        return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAttendees', objAttendees, this.GetHttpOptions());
    }
    public InsertOutlookAttendees(inputVal) {
        return this.http.post(this.apiURL + '/api/MasterMOM/InsertOutlookAttendees', inputVal, this.GetHttpOptions());
    }

    public delAtdComment(inputVal) {

        return this.http.post(this.apiURL + '/api/MasterMOM/DelAtdComment', inputVal, this.GetHttpOptions());
    }
    public insertAtdComment(inputVal) {

        return this.http.post(this.apiURL + '/api/MasterMOM/InsertAtdComment', inputVal, this.GetHttpOptions());
    }
    public getAtdComment(inputVal) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetAtdComment', inputVal, this.GetHttpOptions());
    }

    ////meeting_attendance start
    public getGeneralInfoAtd(objGenInfoAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/GetGeneralInfomation', objGenInfoAtd, this.GetHttpOptions());
    }

    public delGeneralInfoAtd(objGenInfoAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/DelGeneralInfoAtd', objGenInfoAtd, this.GetHttpOptions());
    }

    public publishGeneralInfo(objGenInfoAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/PublishGeneralInfo', objGenInfoAtd, this.GetHttpOptions());
    }

    public createFollowupMeeting(objGenInfoAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/CreateFollowupMeeting', objGenInfoAtd, this.GetHttpOptions());
    }

    public getMOMNumber(objGenInfoAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/GetMOMNumber', objGenInfoAtd, this.GetHttpOptions());
    }
    public addEditGeneralInfoAtd(objGenInfoAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateGeneralInfoAtd', objGenInfoAtd, this.GetHttpOptions());
    }
    public deleteGeneralInfoAtd(objGenInfoAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/DeleteGeneralInfoAtd', objGenInfoAtd, this.GetHttpOptions());
    }
    public getMeetingTypedropsAtd(objGenInfoAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingTypeAtd', objGenInfoAtd, this.GetHttpOptions());
    }
    public getDropMeetingLocationAtd(objGenInfoAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingLocationAtd', objGenInfoAtd, this.GetHttpOptions());
    }
    public getDropMeetingRoomsAtd(objGenInfoAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetDropMeetingRoomAtd', objGenInfoAtd, this.GetHttpOptions());
    }

    //AttendeesAtd
    public getAttendeesAtd(objAttendeesAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/GetAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
    }

    public getAttendeDD(objAttendeesAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/GetAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
    }


    public getGeneralInfoDetails(objAttendeesAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/getGeneralInfoDetails', objAttendeesAtd, this.GetHttpOptions());
    }
    public AttendeColumnUpdate(objAttendeesAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/AttendeColumnUpdate', objAttendeesAtd, this.GetHttpOptions());
    }
    public ApologizedReasonUpdate(objAttendeesAtd) {

        return this.http.post(this.apiURL + '/api/MasterMOM/ApologizedReasonUpdate', objAttendeesAtd, this.GetHttpOptions());
    }

    public addEditAttendeesAtd(objAttendeesAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
    }
    public deleteAttendeesAtd(objAttendeesAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAttendeesAtd', objAttendeesAtd, this.GetHttpOptions());
    }
    // public getUserList(objAttendeesAtd) {
    //     return this.http.post(this.apiURL + '/api/MasterMOM/getUserList', objAttendeesAtd, this.GetHttpOptions());
    // }
    public getDropAtdCategorizeAtd(objAttendeesAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetDropAtdCategorizeAtd', objAttendeesAtd, this.GetHttpOptions());
    }
    public getDropRoleAtd(objAttendeesAtd) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetDropRoleAtd', objAttendeesAtd, this.GetHttpOptions());
    }
    // Fileattachements

  
    public deleteAttachedFile(objSLA) {
        return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAttachedFile', objSLA, this.GetHttpOptions());
    }

    // Agenda
    public addEditAgenda(objAgenda) {
        return this.http.post(this.apiURL + '/api/MasterMOM/InsertUpdateAgendaDetail', objAgenda, this.GetHttpOptions());
    }
    public deleteAgenda(objAgenda) {
        return this.http.post(this.apiURL + '/api/MasterMOM/DeleteAgendaDetails', objAgenda, this.GetHttpOptions());
    }
    public getAgendaDetails(objAgenda) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetAgendaDetails', objAgenda, this.GetHttpOptions());
    }
    public getMOMDashboard(objMoMDashboard) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetMOMDashboard', objMoMDashboard, this.GetHttpOptions());
    }

    public getSearchList(objMoMDashboard) {
        return this.http.post(this.apiURL + '/api/MasterMOM/GetSearchList', objMoMDashboard, this.GetHttpOptions());
    }

   
    //Alert
    public getNotificationList(objAlert) {
        return this.http.post(this.apiURL + '/api/Master/MyNotificationList', objAlert, this.GetHttpOptions());
    }

    public markAsVisited(objAlert) {
        return this.http.post(this.apiURL + '/api/Master/MarkNotificationAsVisited', objAlert, this.GetHttpOptions());
    }

    //IAM oneid
    public addAppln(objFSCType)
    {
        return this.http.post(this.apiURL + '/addApplication', objFSCType, this.GetHttpOptions());
    }

    public userApplnList(objFSCType)
    {
        return this.http.post(this.apiURL + '/userApplicationList', objFSCType, this.GetHttpOptions());
    }

    public AddNewSection(objFSCType)
    {
        return this.http.post(this.apiURL + '/addSection', objFSCType, this.GetHttpOptions());
    }

    public updSection(objFSCType)
    {
        console.log(objFSCType);
        return this.http.post(this.apiURL + '/updSection', objFSCType, this.GetHttpOptions());
    }

    public delSection(objFSCType)
    {
        return this.http.post(this.apiURL + '/delSection', objFSCType, this.GetHttpOptions());
    }

    public addToRecent(objFSCType)
    {
        return this.http.post(this.apiURL + '/addRecentlyUsed', objFSCType, this.GetHttpOptions());
    }

    public refreshToken(objFSCType) {
        return this.http.post(this.apiURL + '/refreshToken', objFSCType, this.GetHttpOptions());
    }
    
    public allApplns(objFSCType)
    {
        return this.http.post(this.apiURL + '/allApplication', objFSCType, this.GetHttpOptions());
    }

    public allUserSections(objFSCType)
    {
        return this.http.post(this.apiURL + '/allUserSections', objFSCType, this.GetHttpOptions());
    }

    public getprofileinfo(objFSCType)
    {
        return this.http.post(this.apiURL + '/userProfileInfo', objFSCType, this.GetHttpOptions());
    }

    public logoutfromoneid()    
    {
        return this.http.get(this.issuerURL + '/as/revoke_token.oauth2');
        //https://smartloginuat.dewa.gov.ae/as/revoke_token.oauth2
        console.log("Called logout url")
    }
    
}
